'use client';

import { useMemo, useState } from 'react';
import { BlogArticleDocument } from '../../../../../../../prismicio-types';
import styles from './article.module.scss';
import { ArticleContent, ArticleHero, SideBar } from '.';
import { CalculatorProps } from '@/types';

interface ArticleProps {
  page: BlogArticleDocument<string>;
}

export const Article = ({ page }: ArticleProps) => {
  const table = useMemo(
    () =>
      page.data.content.filter(
        (item) =>
          item.type === 'Heading' && item.heading.length !== 0 && item.heading
      ),
    [page.data.content]
  );
  const [offsetElement, setOffsetElement] = useState('');

  const calculatorProps: CalculatorProps = {
    variation: 'small',
    min: page.data.calculator_min_value,
    max: page.data.calculator_max_value,
    defaultValue: page.data.calculator_default_value,
    step: page.data.calculator_step,
    resultText: page.data.calculator_result_text,
    rateText: page.data.calculator_interest_rate_text,
    timeLineText: page.data.calculator_time_line_text,
    timeLineValue: page.data.calculator_time_line_value,
    rateValue: page.data.calculator_interest_rate_value,
    title: page.data.calculator_title,
    buttonText: 'See my offers',
    buttonLink: page.data.calculator_button_link,
  };

  return (
    <section className={styles.section}>
      <ArticleHero
        topic={page.data.topic}
        date={page.data.date}
        title={page.data.title}
        image={page.data.image}
      />
      <ArticleContent
        content={page.data.content}
        media={page.data.social_media_links}
        setOffsetElement={setOffsetElement}
      />
      <SideBar
        table={table}
        tableTitle={page.data.table_title}
        offsetElement={offsetElement}
        calculatorProps={calculatorProps}
      />
    </section>
  );
};
